import BigNumber from 'bignumber.js';
import { Timeframe } from '@ankr.com/chains-list';

import { Locale } from 'modules/i18n';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';
import { useTimeframe } from 'modules/chains/components/TimeframeProvider';

import { NetworkUsageCard } from '../NetworkUsageCard';
import { totalRequestsCardTranslation } from './translation';
import { useStats } from '../StatsProvider';

interface TotalRequestsCardProps {
  className?: string;
}

type TooltipsKeys =
  keyof typeof totalRequestsCardTranslation[typeof Locale.en]['tooltips'];

const tooltipKeysMap: Record<Timeframe, TooltipsKeys> = {
  [Timeframe.Day]: 'day',
  [Timeframe.Hour]: 'hour',
  [Timeframe.Month]: 'month',
  [Timeframe.Week]: 'week',
};

export const TotalRequestsCard = ({ className }: TotalRequestsCardProps) => {
  const { isLoggedIn } = useAuth();

  const { timeframe } = useTimeframe();
  const { loading, totalRequests } = useStats();

  const { keys, t } = useTranslation(totalRequestsCardTranslation);

  const tooltipKeys = isLoggedIn ? keys.tooltipsLoggedIn : keys.tooltips;

  return (
    <NetworkUsageCard
      className={className}
      loading={loading}
      title={t(keys.title)}
      tooltip={t(tooltipKeys[tooltipKeysMap[timeframe]])}
      value={new BigNumber(totalRequests).toFormat()}
    />
  );
};
